export default __webpack_public_path__ + "static/media/Coil of the Python.972880d3.jpg";